var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4469_5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2284 11.6668H16.0409V20.4168L22.968 24.573L24.0617 22.7793L18.2284 19.323V11.6668ZM25.2824 2.63968L32.0009 8.24697L30.1342 10.4855L23.4113 4.88114L25.2824 2.63968ZM9.71611 2.63968L11.5857 4.87968L4.86569 10.4855L2.99902 8.24551L9.71611 2.63968ZM17.4992 5.83343C10.2513 5.83343 4.37423 11.7105 4.37423 18.9584C4.37423 26.2063 10.2513 32.0834 17.4992 32.0834C24.7471 32.0834 30.6242 26.2063 30.6242 18.9584C30.6242 11.7105 24.7471 5.83343 17.4992 5.83343ZM17.4992 29.1668C11.8701 29.1668 7.2909 24.5876 7.2909 18.9584C7.2909 13.3293 11.8701 8.7501 17.4992 8.7501C23.1284 8.7501 27.7076 13.3293 27.7076 18.9584C27.7076 24.5876 23.1284 29.1668 17.4992 29.1668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4469_5977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.01cec5ebd5a7de3f2f31334409f6b589.svg";
export { ForwardRef as ReactComponent };